import { render, staticRenderFns } from "./PreferencesPanel.vue?vue&type=template&id=4c6977b0&"
import script from "./PreferencesPanel.vue?vue&type=script&lang=ts&"
export * from "./PreferencesPanel.vue?vue&type=script&lang=ts&"
import style0 from "./PreferencesPanel.vue?vue&type=style&index=0&id=4c6977b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports